const state = {
  processId:'',
  selectedNode: {},
  tagInfoVisible: false,
  diagram: {},
  processDetailInfo: {},
  tagInfoCommand: {},
  documentOption: false
}

const mutations = {
	selectNode (state: any, info: any) {
		// console.log('Process editor mutation select node : ', info , info.text ) ; 
		state.selectedNode = info;
	},
  setProcessId (state: any, info: string) {
    // console.log('Process editor mutation set processId : ', info)
    state.processId = info;
  },
  setDiagram (state: any, info: Object) {
    // console.log('Process editor mutation set diagram: ', info)
    state.diagram = info;
  },
  setProcessDetail (state: any, info: Object) {
    state.processDetailInfo = info
  },
  setTagInfoCommand (state: any, info: Object) {
    // console.log('Process editor mutation set tag command: ', info)
    state.tagInfoCommand = info
  },
  setDocumentOption (state: any, info: boolean) {
    state.documentOption = info
  }
}

const getters = {
	getSelectedNode (state:any) {
		return state.selectedNode
	},
  getProcessId (state: any) {
    return state.processId;
  },
  getDiagram (state: any) {
    return state.diagram;
  },
  getProcessDetail (state: any) {
    return state.processDetailInfo;
  },
  getTagInfoCommand (state: any) {
    // console.log('Getter getTagInfoCommand : ', state);
    return state.tagInfoCommand;
  },
  getDocumentOption (state: any) {
    return state.documentOption;
  }
}

export default {
	namespaced: true,
	state ,
	mutations , 
	getters ,
}